/* assets/pdp.js
   Solely Jane Product Detail page — real rebuild matching the design
   source's PRODUCT DETAIL screen. Drives the gallery (main image + up to
   2 curated "on Black/Brown base" thumbnails, correct for whichever
   color swatch is active), color swatches, size chips, Add to Cart, and
   the Top-Only "add a base" / Base-Only "pick tops" inline modules, all
   against the real Shopify variant graph embedded by sections/pdp.liquid.
*/
(function () {
  'use strict';

  var root = document.getElementById('pdp');
  if (!root) return;

  var cartAddUrl = root.dataset.cartAddUrl || '/cart/add.js';

  var configEl = root.querySelector('[data-pdp-config]');
  var CONFIG = configEl ? JSON.parse(configEl.textContent) : { hasColor: false, variants: [], defaultImage: '' };

  var comboConfigEl = root.querySelector('[data-pdp-combomap]');
  var COMBO_LIST = comboConfigEl ? JSON.parse(comboConfigEl.textContent) : [];

  var baseConfigEl = root.querySelector('[data-pdp-baseconfig]');
  var BASES = baseConfigEl ? JSON.parse(baseConfigEl.textContent) : [];

  function money(cents) {
    var n = Number(cents) / 100;
    return '$' + (Number.isInteger(n) ? n : n.toFixed(2));
  }

  function comboForColor(color) {
    if (!COMBO_LIST.length) return null;
    var match = COMBO_LIST.find(function (c) { return c.color === color; });
    if (match) return match;
    // Only fall back to the single generic pair when the product has no
    // Color option at all. For multi-color products, a color with no
    // dedicated combo photography should show no extra thumbnails rather
    // than borrowing another color's images.
    if (!CONFIG.hasColor) return COMBO_LIST[0];
    return null;
  }

  // ---------- Gallery ----------
  var $mainImg = root.querySelector('[data-pdp-mainimg]');
  var $galleryBadge = root.querySelector('[data-pdp-gallerybadge]');
  var $thumbsWrap = root.querySelector('[data-pdp-thumbs]');

  function makeThumb(img, badge, isActive) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pdp__thumb' + (isActive ? ' is-active' : '');
    btn.innerHTML = '<img src="' + img + '" alt="" loading="lazy">';
    btn.addEventListener('click', function () {
      $thumbsWrap.querySelectorAll('.pdp__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      btn.classList.add('is-active');
      if ($mainImg) $mainImg.src = img;
      if ($galleryBadge) {
        if (badge) { $galleryBadge.textContent = badge; $galleryBadge.hidden = false; }
        else { $galleryBadge.hidden = true; }
      }
    });
    return btn;
  }

  function renderGallery(color, defaultImg) {
    if (!$thumbsWrap) return;
    $thumbsWrap.innerHTML = '';
    var combo = comboForColor(color);
    // Always show at least the main product photo as a thumbnail, even when
    // this color has no dedicated combo photography — hiding the whole strip
    // left a jarring empty gap for colors like Adelaide's Tan (no on-base
    // photography exists for that color, but the gallery should never look
    // "broken" or empty).
    $thumbsWrap.hidden = false;
    $thumbsWrap.appendChild(makeThumb(defaultImg, '', true));
    // Guard against duplicate thumbnails: when a color has no genuine
    // standalone photo on file, selectColor() falls back to using one of
    // the combo shots (on-Black-base or on-Brown-base) as the main/thumb1
    // image. In that case the SAME photo must not also be re-added as its
    // own separate combo thumbnail below — only add a combo thumb if it's
    // a different photo than what's already shown as thumb1.
    if (combo && combo.black && combo.black !== defaultImg) $thumbsWrap.appendChild(makeThumb(combo.black, 'Black Base Shown is not included', false));
    if (combo && combo.brown && combo.brown !== defaultImg) $thumbsWrap.appendChild(makeThumb(combo.brown, 'Brown Base Shown is not included', false));
    if ($mainImg && defaultImg) $mainImg.src = defaultImg;
    if ($galleryBadge) $galleryBadge.hidden = true;
  }

  // ---------- Product state ----------
  var state = { color: null, size: null };

  var $swatches = root.querySelectorAll('[data-pdp-swatch]');
  var $swatchLabel = root.querySelector('[data-pdp-swatchlabel]');
  var $sizeChips = root.querySelector('[data-pdp-sizechips]');
  var $addBtn = root.querySelector('[data-pdp-add]');
  var $price = root.querySelector('[data-pdp-price]');

  if (CONFIG.hasColor && $swatches.length) {
    state.color = $swatches[0].getAttribute('data-color');
  }

  function variantsForColor(color) {
    return CONFIG.variants.filter(function (v) {
      return !CONFIG.hasColor || v.color === color;
    });
  }

  function renderSizeChips() {
    if (!$sizeChips) return;
    $sizeChips.innerHTML = '';
    variantsForColor(state.color).forEach(function (v) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'pdp__sizechip' + (state.size === v.size ? ' is-selected' : '') + (!v.available ? ' is-unavailable' : '');
      chip.textContent = v.size;
      chip.disabled = !v.available;
      chip.addEventListener('click', function () {
        state.size = v.size;
        renderSizeChips();
        renderAddButton();
      });
      $sizeChips.appendChild(chip);
    });
  }

  function currentVariant() {
    return CONFIG.variants.find(function (v) {
      return (!CONFIG.hasColor || v.color === state.color) && v.size === state.size;
    });
  }

  function renderAddButton() {
    var v = currentVariant();
    if (!$addBtn) return;
    if (v) {
      $addBtn.disabled = false;
      $addBtn.classList.add('is-ready');
      $addBtn.textContent = 'Add to Cart · ' + money(v.price);
      if ($price) $price.textContent = money(v.price);
    } else {
      $addBtn.disabled = true;
      $addBtn.classList.remove('is-ready');
      $addBtn.textContent = 'Select a size';
    }
  }

  function selectColor(color) {
    state.color = color;
    state.size = null;
    $swatches.forEach(function (sw) {
      sw.classList.toggle('is-active', sw.getAttribute('data-color') === color);
    });
    if ($swatchLabel) $swatchLabel.textContent = 'Color: ' + color;
    // Main/thumb1 image priority: the color's own genuine standalone
    // "top only, no base" photo (tagged "{Color} top only, standalone")
    // first — this is what the Shop/collection grid shows before the
    // shopper ever clicks into the PDP. Shopify's legacy per-variant
    // `image` field is deliberately NOT used here: for several colors it
    // turned out to be either a duplicate of an on-base combo photo or
    // some other on-base shot entirely, never the flat standalone. If a
    // color has no standalone photo on file, fall back to one of its own
    // real on-base combo photos (still correctly colored) before finally
    // falling back to the product's generic default image.
    var combo = comboForColor(color);
    var imgUrl = (combo && (combo.standalone || combo.black || combo.brown)) || CONFIG.defaultImage;
    renderGallery(color, imgUrl);
    renderSizeChips();
    renderAddButton();
  }

  $swatches.forEach(function (sw) {
    sw.addEventListener('click', function () {
      selectColor(sw.getAttribute('data-color'));
    });
  });

  if (CONFIG.hasColor && state.color) {
    selectColor(state.color);
  } else {
    renderGallery(null, CONFIG.defaultImage);
  }
  renderSizeChips();
  renderAddButton();

  // ---------- Toast ----------
  var $toast = root.querySelector('[data-pdp-toast]');
  var toastTimer;
  function showToast(msg) {
    if (!$toast) return;
    $toast.textContent = msg;
    $toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { $toast.hidden = true; }, 2200);
  }

  function idNumber(gid) {
    var m = String(gid).match(/(\d+)$/);
    return m ? parseInt(m[1], 10) : gid;
  }

  // 2026-07-24: switched from a hand-rolled fetch(cartAddUrl) + drawer.open()
  // call to the theme's own <cart-items> controller (identical fix + same
  // reasoning as assets/bundle-builder.js — see the comment above that
  // file's "Add to cart" section for full detail). Root cause of the old
  // bug: <cart-drawer>'s real open method is openCartDrawer(), not open(),
  // so `typeof drawer.open === 'function'` was always false and the drawer
  // never opened / cart-count badge never refreshed. cart-items.addToCart()
  // is what every native Add to Cart button on this theme actually calls.
  // Kept as a Promise wrapper so existing callers (the "add a base to cart"
  // flow below) can keep chaining .then() exactly as before. Matching the
  // original contract, the returned promise resolves whether the add
  // succeeded or failed (the error case still shows an error toast first) so
  // callers' post-add cleanup (resetting the base picker, etc.) still runs.
  function addToCart(variantId, successMsg) {
    return new Promise(function (resolve) {
      var cartItemsEl = document.querySelector('cart-items');

      if (cartItemsEl && typeof cartItemsEl.addToCart === 'function') {
        var settled = false;
        var proxyBtn = document.createElement('button');
        var finish = function () {
          if (settled) return;
          settled = true;
          clearTimeout(safetyTimer);
          showToast(successMsg);
          resolve();
        };
        var safetyTimer = setTimeout(finish, 6000); // safety net if the event never fires
        proxyBtn.addEventListener('theme:product:add', finish);
        cartItemsEl.addToCart([{ id: idNumber(variantId), quantity: 1 }], proxyBtn);
      } else {
        // Fallback for older/alternate cart markup where <cart-items> isn't present.
        fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: idNumber(variantId), quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart add failed');
            return res.json();
          })
          .then(function () {
            showToast(successMsg);
            document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));
            resolve();
          })
          .catch(function () {
            showToast('Something went wrong — please try again.');
            resolve();
          });
      }
    });
  }

  if ($addBtn) {
    $addBtn.addEventListener('click', function () {
      var v = currentVariant();
      if (!v) return;
      addToCart(v.id, root.dataset.productTitle + ' added to cart');
    });
  }

  // ---------- Top-only: "add a base to cart" module ----------
  var $toggleBase = root.querySelector('[data-pdp-togglebase]');
  var $baseAdd = root.querySelector('[data-pdp-baseadd]');
  var $baseColorBtns = root.querySelectorAll('[data-pdp-basecolor]');
  var $baseSizeChips = root.querySelector('[data-pdp-basesizes]');
  var $addBaseBtn = root.querySelector('[data-pdp-addbase]');
  var baseState = { color: null, size: null };

  if ($toggleBase && $baseAdd) {
    $toggleBase.addEventListener('click', function () {
      var open = $baseAdd.hidden;
      $baseAdd.hidden = !open;
      $toggleBase.textContent = open ? 'Hide base options' : '+ Add a base to cart';
    });
  }

  function baseVariantsForColor(color) {
    var entry = BASES.find(function (b) { return b.color === color; });
    return entry ? entry.variants : [];
  }

  function renderBaseSizeChips() {
    if (!$baseSizeChips) return;
    $baseSizeChips.innerHTML = '';
    baseVariantsForColor(baseState.color).forEach(function (v) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'pdp__sizechip pdp__sizechip--compact' + (baseState.size === v.size ? ' is-selected' : '') + (!v.available ? ' is-unavailable' : '');
      chip.textContent = v.size;
      chip.disabled = !v.available;
      chip.addEventListener('click', function () {
        baseState.size = v.size;
        renderBaseSizeChips();
        renderAddBaseButton();
      });
      $baseSizeChips.appendChild(chip);
    });
  }

  function currentBaseVariant() {
    return baseVariantsForColor(baseState.color).find(function (v) { return v.size === baseState.size; });
  }

  function renderAddBaseButton() {
    if (!$addBaseBtn) return;
    var v = currentBaseVariant();
    if (v) {
      $addBaseBtn.disabled = false;
      $addBaseBtn.classList.add('is-ready');
      $addBaseBtn.textContent = 'Add ' + baseState.color + ' base to cart · ' + money(v.price);
    } else {
      $addBaseBtn.disabled = true;
      $addBaseBtn.classList.remove('is-ready');
      $addBaseBtn.textContent = 'Select a color and size';
    }
  }

  $baseColorBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      baseState.color = btn.getAttribute('data-color');
      baseState.size = null;
      $baseColorBtns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      renderBaseSizeChips();
      renderAddBaseButton();
    });
  });

  if ($addBaseBtn) {
    $addBaseBtn.addEventListener('click', function () {
      var v = currentBaseVariant();
      if (!v) return;
      addToCart(v.id, baseState.color + ' base added to cart').then(function () {
        baseState = { color: null, size: null };
        $baseColorBtns.forEach(function (b) { b.classList.remove('is-active'); });
        renderBaseSizeChips();
        renderAddBaseButton();
        if ($baseAdd) $baseAdd.hidden = true;
        if ($toggleBase) $toggleBase.textContent = '+ Add a base to cart';
      });
    });
  }
})();
